import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "lsk_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  });
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const addItem = (entry) => {
    setItems((prev) => {
      // Combine identical lines (non-combo)
      if (!entry.is_combo) {
        const idx = prev.findIndex(
          (p) => !p.is_combo && p.item_id === entry.item_id
        );
        if (idx >= 0) {
          const copy = [...prev];
          copy[idx] = { ...copy[idx], quantity: copy[idx].quantity + (entry.quantity || 1) };
          return copy;
        }
      }
      return [
        ...prev,
        {
          line_id: crypto.randomUUID(),
          quantity: 1,
          ...entry,
        },
      ];
    });
    setDrawerOpen(true);
  };

  const updateQty = (line_id, delta) => {
    setItems((prev) =>
      prev
        .map((p) => (p.line_id === line_id ? { ...p, quantity: Math.max(0, p.quantity + delta) } : p))
        .filter((p) => p.quantity > 0)
    );
  };

  const removeItem = (line_id) =>
    setItems((prev) => prev.filter((p) => p.line_id !== line_id));

  const clear = () => setItems([]);

  const total = useMemo(
    () => items.reduce((s, i) => s + i.unit_price * i.quantity, 0),
    [items]
  );
  const count = useMemo(() => items.reduce((s, i) => s + i.quantity, 0), [items]);

  return (
    <CartContext.Provider
      value={{ items, addItem, updateQty, removeItem, clear, total, count, drawerOpen, setDrawerOpen }}
    >
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be inside CartProvider");
  return ctx;
};
